const newTask = {
  titles: {
    onetime: "Perfil de Tarea Única",
    recurrent: "Perfil de Tarea Periódica"
  },
  labels: {
    tag: "Tag del Equipo",
    alertTime: "Tiempo de Alerta",
    lifetime: "Duración Total",
    name: "Nombre de la Tarea",
    description: "Descripción",
    type: "Tipo de Tarea",
    due: "Vencimiento",
    subtypes: {
      maintenance: "mantenimiento",
      repair: "reparación",
      reliability: "confiabilidad"
    }
  },
  headers: {
    notificationFrequency: "Frecuencia de Notificación",
    taskFrequency: "Frecuencia de la Tarea"
  },
  buttons: {
    ok: "ACEPTAR",
    cancel: "CANCELAR",
    submit: "ENVIAR",
    back: "Atrás",
    gotoTaskProfile: "Ir al Perfil de la Tarea",
    gotoCreateTask: "Crear otra Tarea",
    gotoPlanner: "Ir al Planificador"
  },
  messages: {
    notificationFrequency:
      "Corresponde al periodo de tiempo en el cual la tarea debe ser repetida",
    taskFrequency:
      "Corresponde al periodo de tiempo en el cual la tarea será notificada. Esta debe ser menor a la frecuencia de la tarea",
    finaltext:
      "El tiempo de alerta debe ser menor a la duración total de la tarea"
  },
  date: {
    day: "dia",
    week: "semana",
    month: "mes",
    year: "año"
  }
};
export default newTask;
